import Step from "components/Step";
import Dashboard from "components/Template/Dashboard";
import { ReactComponent as ArrowLeft } from "icons/arrow-circle-left-green.svg";
import ArrowRight from "icons/arrow-right.svg";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ChildrenNames from "./ChildrenNames";
import FamilyDetails from "./FamilyDetails";
import PaymentDetails from "./PaymentDetails";

type Props = {};

type breadcrumbData = {
  name: string;
  active: boolean;
  path?: string;
};

const GroupManagementStore: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [steps, setSteps] = useState<number>(1);
  const [stepData, setStepData] = useState<Array<any>>([]);
  const [breadcrumb, setBreadcrumb] = useState<Array<any>>([]);
  const [groupChildrenName, setGroupChildrenName] = useState("");

  useEffect(() => {
    if (
      history?.location?.state?.step === 2 &&
      steps === 1 &&
      history?.location?.state?.groupId
    ) {
      localStorage.setItem("groupId", history?.location?.state?.groupId);
      setSteps(2);
    }

    if (steps === 1) {
      setBreadcrumb([
        { name: "Add New Group", active: false },
        { name: "Payment Details", active: true },
      ]);
      setStepData([
        {
          title: "1",
          active: true,
        },
        {
          title: "2",
          active: false,
        },
        {
          title: "3",
          active: false,
        },
      ]);
    }

    if (steps === 2) {
      setBreadcrumb([
        { name: "Add New Group", active: false },
        { name: "Enter Child’s Name and Select Plan", active: true },
      ]);
      setStepData([
        {
          title: "1",
          active: false,
        },
        {
          title: "2",
          active: true,
        },
        {
          title: "3",
          active: false,
        },
      ]);
    }

    if (steps === 3) {
      setBreadcrumb([
        { name: "Add New Group", active: false },
        { name: "Add Family Details", active: true },
      ]);
      setStepData([
        {
          title: "1",
          active: false,
        },
        {
          title: "2",
          active: false,
        },
        {
          title: "3",
          active: true,
        },
      ]);
    }
  }, [
    history?.location?.state?.step,
    history?.location?.state?.groupId,
    steps,
  ]);

  const returnBreadcrumb = (breadcrumb: breadcrumbData[]): JSX.Element => {
    return (
      <div className="flex flex-row">
        {breadcrumb.map((b: breadcrumbData, i, row) => (
          <Fragment key={i}>
            <div
              className={`flex flex-col font-sora text-base ${
                b.active ? " text-bt-green" : "text-bt-gray-500"
              }`}
              style={{
                fontStyle: "normal",
                fontWeight: 400,
              }}
            >
              {b.name}
            </div>
            {i + 1 === row.length ? (
              <></>
            ) : (
              <img
                src={ArrowRight}
                alt="building"
                width={20}
                height={10}
                className="mx-2"
              />
            )}
          </Fragment>
        ))}
      </div>
    );
  };

  return (
    <Dashboard
      breadcrumb={breadcrumb}
      children={
        <>
          <section className="mb-8">
            {breadcrumb.length > 0 ? returnBreadcrumb(breadcrumb) : ""}
            <div className="flex flex-row">
              {steps !== 1 ? (
                <div className="flex flex-col">
                  <div
                    className={`flex flex-col cursor-pointer mr-2 mt-11`}
                    onClick={() => {
                      if (steps === 2) {
                        setSteps(1);
                      } else if (steps === 3) {
                        setSteps(2);
                      }
                    }}
                  >
                    <ArrowLeft />
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="flex flex-col mt-10">
                <h1
                  className="font-sora text-2xl"
                  style={{
                    fontStyle: "normal",
                    fontWeight: 600,
                    color: "#408e5a",
                  }}
                >
                  Add New Family
                </h1>
              </div>
            </div>
          </section>
          <div className="flex flex-col">
            <div className="flex flex-row items-center justify-center mb-3">
              <Step stepData={stepData} />
            </div>
            <div className="bg-bt-white p-6">
              {steps === 1 && (
                <PaymentDetails steps={steps} setSteps={setSteps} />
              )}
              {steps === 2 && (
                <ChildrenNames
                  setSteps={setSteps}
                  setGroupChildrenName={setGroupChildrenName}
                />
              )}
              {steps === 3 && (
                <FamilyDetails groupChildrenName={groupChildrenName} />
              )}
            </div>
          </div>
        </>
      }
    />
  );
};

export default GroupManagementStore;
